//@ts-nocheck
import React from "react";

import { useIntl } from "react-intl";

import { AtlassianLogo } from "@atlaskit/logo";

const DefaultHeader = () => {
    const intl = useIntl();
    const logoLabel = intl.formatMessage({
        id: "SiteSelectorModal.atlassianLogoLabel",
        defaultMessage: "Atlassian logo"
    });

    return <AtlassianLogo size="medium" label={logoLabel} />;
};

export default DefaultHeader;
